import { useState, useEffect, useContext } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { base_url } from '../url_variables';
import axios from 'axios';
import { UserContext } from "../context/UserContext";
import { GridLoader } from "react-spinners";
import { TopBar } from "../components/topbar";

export default function ProfileSetup() {
  const navigate = useNavigate();
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [profilePic, setProfilePic] = useState(null);
  const [preview, setPreview] = useState(null);
  const [cookies] = useCookies();
  const [profileData, setProfileData] = useState(null);
  const [formData, setFormData] = useState(null);
  const [loaading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  // Handle profile picture upload & preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePic(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle input changes
  const handleChange = async (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit form
  const handleSubmit = async () => {
    // e.preventDefault();
    console.log("Updated Profile:", formData, profilePic);

    setLoading(true);
    const postData = new FormData();

    for (const [key, value] of Object.entries(formData)) {
        postData.append(key, value);
    }
    postData.append('profilePic', profilePic);

    try {
        const response = await axios.post(base_url + '/update-profile.php', postData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "token": cookies?.userProfile?.session,
                "memberno": cookies?.userProfile?.main_id,
            },
        });
        console.log(response);
        if (response.data.status) {
            setLoading(false);
            alert(response.data.response);
            window.location.reload();
        } else {
            alert(response.data.response);
            setLoading(false);
        }
    } catch (error) {
        setLoading(false);
    }
  };

    useEffect(() => {
        getData();
    }, [])

    async function getData() {
        setPageLoading(true)
        try {
            const response = await axios.get(base_url + '/profile.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    memberno: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setProfileData(response.data.data);
                setFormData(response.data.data);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col">
        {pageLoading && (
        <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
            <GridLoader
                color={'#000080'}
                loading={true}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
        )}
        <TopBar title={'Edit Profile'} />
        <form className="space-y-5 pb-6 px-10">
            {/* Profile Picture */}
            <div className="flex flex-col items-center">
            <label htmlFor="profilePic" className="cursor-pointer">
                <img
                src={preview || formData?.member_image}
                alt="Profile Preview"
                className="w-28 h-28 object-cover rounded-full border-4 border-gray-200 shadow-md"
                />
            </label>
            <input
                type="file"
                id="profilePic"
                accept="image/*"
                onChange={handleImageChange}
                className="hidden"
            />
            <p className="text-sm text-gray-500 mt-2">Click to change picture</p>
            </div>

            {/* Name */}
            <div>
            <label className="block font-medium">Full Name</label>
            <input
                type="text"
                name="name"
                value={formData?.name}
                onChange={handleChange}
                placeholder="Enter your name"
                className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
            />
            </div>

            {/* Email */}
            <div>
            <label className="block font-medium">Email</label>
            <input
                type="email"
                name="email"
                value={formData?.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
            />
            </div>

            {/* Phone */}
            <div>
            <label className="block font-medium">Home Phone</label>
            <input
                type="home_phone"
                name="home_phone"
                value={formData?.home_phone}
                onChange={handleChange}
                placeholder="Enter your home phone"
                className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
            />
            </div>

            {/* Office Phone */}
            <div>
            <label className="block font-medium">Office Phone</label>
            <input
                type="office_phone"
                name="office_phone"
                value={formData?.office_phone}
                onChange={handleChange}
                placeholder="Enter your office phone"
                className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
            />
            </div>

            {/* Date of Birth */}
            <div>
            <label className="block font-medium">Date of Birth</label>
            <input
                type="date"
                name="member_dob"
                value={formData?.member_dob}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
            />
            </div>
            <div className="flex flex-row w-full justify-between">
                <div className="w-[44%]">
                    <label className="block font-medium">Nationality</label>
                    <input
                        type="text"
                        name="nationality"
                        value={formData?.nationality}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
                <div className="w-[44%]">
                    <label className="block font-medium">State of Origin</label>
                    <input
                        type="text"
                        name="state_of_origin"
                        value={formData?.state_of_origin}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
            </div>

            {/* Bio */}
            <div className="flex flex-row w-full justify-between">
                <div className="w-[44%]">
                    <label className="block font-medium">Business Address</label>
                    <textarea
                        name="business_address"
                        value={formData?.business_address}
                        onChange={handleChange}
                        rows="3"
                        placeholder="Tell us about yourself"
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    ></textarea>
                </div>
                <div className="w-[44%]">
                    <label className="block font-medium">Residential Address</label>
                    <textarea
                        name="residential_address"
                        value={formData?.residential_address}
                        onChange={handleChange}
                        rows="3"
                        placeholder="Tell us about yourself"
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    ></textarea>
                </div>
            </div>

            <div className="flex flex-row w-full justify-between">
                <div className="w-[44%]">
                    <label className="block font-medium">Occupation</label>
                    <input
                        type="text"
                        name="occupation"
                        value={formData?.occupation}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
                <div className="w-[44%]">
                    <label className="block font-medium">Nature of Business</label>
                    <input
                        type="text"
                        name="nature_of_business"
                        value={formData?.nature_of_business}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
            </div>

            <div className="flex flex-row w-full justify-between">
                <div className="w-[44%]">
                    <label className="block font-medium">Employer</label>
                    <input
                        type="text"
                        name="employer"
                        value={formData?.employer}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
                <div className="w-[44%]">
                    <label className="block font-medium">Employment Position</label>
                    <input
                        type="text"
                        name="employment_position"
                        value={formData?.employment_position}
                        onChange={handleChange}
                        className="w-full p-2 border rounded-lg mt-1 focus:ring-2 focus:ring-blue-400"
                    />
                </div>
            </div>

            {/* Save Button */}
            <div className="text-center mt-[20px] w-full flex justify-end">
            <button
                type="button"
                onClick={() => handleSubmit()}
                className={`px-6 py-2 bg-[#000080] text-white rounded-lg hover:bg-blue-700 transition ${profileData == formData ? 'opacity-[0.7]' : ''}`}
            >
                Save Changes
            </button>
            </div>
      </form>
    </div>
  );
}
